import "react-datetime/css/react-datetime.css";
import React, { useEffect, useState, Fragment } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import {
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import Icon from "@mdi/react";
import {
  mdiChevronDown,
  mdiMagnify,
  mdiMenu,
  mdiStopCircleOutline,
  mdiVolumeHigh,
} from "@mdi/js";
import { useLocation } from "react-router-dom";
import { getVinList } from "../../../redux/action/action";
import { useDispatch } from "react-redux";
import { atom } from "jotai";
import moment from "moment";
import { UseContextData } from "../../../context/dateContext";
import { Dialog, Transition } from "@headlessui/react";
import { UseManageData } from "../../../context/manageData";
import ToggleSwitch from "../../switch/ToggleSwitch";
import { useTranslation } from "react-i18next";
import baseUrl from "../../../util/baseUrl";
import axios from "axios";
import { LayoutContext } from "../Layout/Layout";
import { useContext } from "react";
export const VehicleId = atom("");
export const DefaultFleetName = atom("midwest");

const Header = ({ children, selectedMenu }) => {
  const {
    date,
    setDate,
    search,
    setSearch,
    selectedVin,
    setSelectedVin,
    fleetName,
    setfleetName,
    formatDate,
    setFormatDate,
    isDarkTheme,
    selectedLanguage,
    setSelectedLanguage,
    setselectedTimeStamp,
    selectedTimeStamp,
    selectedButton,
    setSelectedButton,
  } = UseContextData();

  const { setOpenSidebar } = useContext(LayoutContext);
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const selectedVehicleId = queryParams.get("selectedVin");
  const [defaultDate, setDefaultDate] = useState(date);
  const [vinList, setVinList] = useState({});
  const [open, setOpen] = useState(false);
  const vinListArray = Object.values(vinList);
  const [selectedFleet, setSelectedFleet] = useState("midwest");
  const [selectFrequency, setSelectFrequency] = useState("Set Frequency");
  // const currentDate = new Date()
  // const [formatDate, setFormatDate] = useState(moment(currentDate).format('D MMM h:mm A'));
  const routePath = [
    "/fleet_view",
    "/fleet_view_map",
    "/digital_twins",
    "/fuel_net",
    "/canvas",
    "/econet",
    "/batterynet",
    "/",
  ];
  const [selectedMenuOption, setSelectedMenuOption] = useState("Real Time");
  const { stateData } = UseManageData();
  const { t } = useTranslation();
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [audioObject, setAudioObject] = useState();
  const [snapshotData, setSnapshotData] = useState(null);

  const handleVehicleChange = (vin) => {
    setSelectedVin(vin);
  };

  const handleDateChange = (newDate) => {
    const formattedDate = moment(newDate).format("YYYY-MM-DD");
    setDate(formattedDate);
    // setDefaultDate(formattedDate);
  };
  const fleetOptions = [
    {
      label: t("Midwest"),
      value: t("midwest"),
    },
  ];

  const frequencyOptions = [
    {
      label: t("Real Time"),
      value: t("Real Time"),
    },
    {
      label: t("Daily"),
      value: t("daily"),
    },
    {
      label: t("Weekly"),
      value: t("weekly"),
    },
    {
      label: t("Monthly"),
      value: t("monthly"),
    },
  ];

  useEffect(() => {
    setSelectedVin(selectedVehicleId || "TGdOtwPPBvxoRHV");
    // setDefaultDate("2022-01-01");
    setDate("2022-01-01");
  }, []);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await dispatch(getVinList());
        const vinData = response?.payload?.data?.vin;

        if (vinData) {
          setVinList(vinData);
        }
      } catch (error) {
        console.error("Error fetching vinList:", error);
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const updatedDate = moment().format("D MMM h:mm A");
      setFormatDate(updatedDate);
    }, 100);

    return () => clearInterval(intervalId);
  }, []);

  const languages = [
    { code: "en", lang: "English" },
    { code: "fr", lang: "French" },
    { code: "hi", lang: "Hindi" },
    { code: "ar", lang: "Arabic" },
  ];

  const { i18n } = useTranslation();

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n, i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const text = `Take Action! ${stateData?.VehiclesNeedAttention} vehicle need attention. ${stateData?.safety} vehicles might have a safety issue. ${stateData?.Tire_issue} vehicles will need new tires next week. ${stateData?.Batteries} vehicles will need preventive battery maintenance next month. ${stateData?.efficiencyIssue} vehicles can improve its efficiency. ${stateData?.driverHabitIssue} drivers improved their habits, resulting in a 3% efficiency gain for your fleet`;

  const speak = async () => {
    if (isSpeaking) {
      stopAudio();
    }
    setIsSpeaking(true);
    setSnapshotData(stateData);
    try {
      const response = await axios.get(
        `${baseUrl}/text_to_speech?text=${encodeURIComponent(
          text
        )}&language=${selectedLanguage}`,
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], { type: "audio/mp3" });
      const blobUrl = URL.createObjectURL(blob);
      const audio = new Audio(blobUrl);
      audio.onended = () => {
        setIsSpeaking(false);
      };
      audio.play();
      setAudioObject(audio);
    } catch (err) {
      console.log("Error converting text to speech", err);
    }
  };
  const stopAudio = () => {
    if (audioObject) {
      audioObject.pause();
      audioObject.currentTime = 0;
      setIsSpeaking(false);
      setAudioObject(null);
    }
  };

  useEffect(() => {
    if (!open) {
      stopAudio();
    }
  }, [open]);

  const displayedData = isSpeaking ? snapshotData : stateData;

  if (!displayedData) {
    return null;
  }

  const handleCheckboxChange = (checkboxName) => {
    setSelectedButton((prevState) => {
      if (prevState.includes(checkboxName)) {
        return prevState.filter((item) => item !== checkboxName);
      } else {
        return [...prevState, checkboxName];
      }
    });
  };

  const translatedTimeStamp =
    selectedTimeStamp === "daily"
      ? t("timeStamps.daily")
      : selectedTimeStamp === "weekly"
      ? t("timeStamps.weekly")
      : selectedTimeStamp === "monthly"
      ? t("timeStamps.monthly")
      : t("timeStamps.default");

  return (
    <div className="flex md:w-full flex-col justify-between gap-4">
      <div className="w-full h-14 px-4 bg-white dark:bg-[#444444] dark:text-white border border-primary rounded-lg flex md:hidden  items-center justify-between">
        <div className="text-sm p-2">Search</div>
        <Icon
          path={mdiMenu}
          onClick={() => setOpenSidebar(true)}
          size={"25px"}
          className="ml-2 h-4 text-dark1 dark:text-white cursor-pointer"
        />
      </div>

      <div className="flex max-w-sm md:max-w-none md:justify-start overflow-auto gap-4 ">
        <Menu>
          <MenuHandler>
            <div className="py-3 px-2 h-10 bg-white dark:bg-[#444444] dark:text-white border border-primary rounded-lg flex items-center justify-between cursor-pointer">
              <div className="text-sm">{selectedVin || "Vehicle Id"}</div>
              <Icon
                path={mdiChevronDown}
                size={"25px"}
                className="ml-2 h-4 text-dark1 dark:text-white"
              />
            </div>
          </MenuHandler>
          <MenuList className="dark:bg-[#444444] dark:text-white dark:border-primary">
            {vinListArray?.map((vinItem, index) => (
              <MenuItem
                key={index}
                onClick={() => handleVehicleChange(vinItem)}
                value={vinItem}
              >
                {vinItem}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        <Menu>
          <MenuHandler>
            <div className="py-4 px-2 h-10 bg-white dark:bg-[#444444] dark:text-white border border-primary rounded-lg flex items-center justify-between cursor-pointer">
              <div className="text-sm">{t(selectedFleet)}</div>
              <Icon
                path={mdiChevronDown}
                size={"25px"}
                className="ml-2 h-4 text-dark1 dark:text-white"
              />
            </div>
          </MenuHandler>
          <MenuList className="dark:bg-[#444444] dark:text-white dark:border-primary">
            {fleetOptions?.map((fleetItem, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  setSelectedFleet(fleetItem.value);
                }}
              >
                {fleetItem.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        <Menu>
          <MenuHandler>
            <div className="py-4 px-2 h-10 bg-white border dark:bg-[#444444] dark:text-white border-primary rounded-lg flex items-center justify-between cursor-pointer">
              <div className="text-sm">{t(selectFrequency)}</div>
              <Icon
                path={mdiChevronDown}
                size={"25px"}
                className="ml-2 h-4 text-dark1 dark:text-white"
              />
            </div>
          </MenuHandler>
          <MenuList className="dark:bg-[#444444] dark:text-white dark:border-primary">
            {frequencyOptions?.map((item, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  setSelectFrequency(item.label);
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        {/* <Menu>
          <MenuHandler>
            <div className="py-3 px-2 h-10 bg-white dark:bg-[#444444] dark:text-white border border-primary rounded-lg flex items-center justify-between cursor-pointer">
              <div className="text-sm">{t(selectedMenuOption)}</div>
              <Icon
                path={mdiChevronDown}
                size={"25px"}
                className="ml-2 h-4 text-dark1 dark:text-white"
              />
            </div>
          </MenuHandler>
          <MenuList className="dark:bg-[#444444] dark:text-white dark:border-primary">
            <MenuItem
              onClick={() => {
                setSelectedMenuOption("Real Time");
                selectedMenu("Real Time");
              }}
              selected={selectedMenuOption === "Real Time"}
            >
              {t("Real Time")}
            </MenuItem>
          </MenuList>
        </Menu>
        <Menu>
          <MenuHandler>
            <div className="py-3 px-2 h-10 bg-white dark:bg-[#444444] dark:text-white border border-primary rounded-lg flex items-center justify-between cursor-pointer">
              <div className="text-sm">{translatedTimeStamp}</div>
              <Icon
                path={mdiChevronDown}
                size={"25px"}
                className="ml-2 h-4 text-dark1 dark:text-white"
              />
            </div>
          </MenuHandler>
          <MenuList className="dark:bg-[#444444] dark:text-white dark:border-primary">
            <MenuItem onClick={() => setselectedTimeStamp("daily")}>
              {t("Daily")}
            </MenuItem>
            <MenuItem onClick={() => setselectedTimeStamp("weekly")}>
              {t("Weekly")}
            </MenuItem>
            <MenuItem onClick={() => setselectedTimeStamp("monthly")}>
              {t("Monthly")}
            </MenuItem>
          </MenuList>
        </Menu> */}
        <Menu>
          <MenuHandler>
            <div className="py-3 px-2 h-10 bg-white dark:bg-[#444444] dark:text-white border border-primary rounded-lg flex items-center justify-between cursor-pointer">
              <div className="text-sm">{selectedLanguage}</div>
              <Icon
                path={mdiChevronDown}
                size={"25px"}
                className="ml-2 h-4 text-dark1 dark:text-white"
              />
            </div>
          </MenuHandler>
          <MenuList className="dark:bg-[#444444] dark:text-white dark:border-primary">
            <MenuItem
              onClick={() => {
                changeLanguage("en");
                setSelectedLanguage("English");
              }}
            >
              English
            </MenuItem>
            <MenuItem
              onClick={() => {
                changeLanguage("es");
                setSelectedLanguage("Spanish");
              }}
            >
              Spanish
            </MenuItem>
            <MenuItem
              onClick={() => {
                changeLanguage("zh");
                setSelectedLanguage("Chinese");
              }}
            >
              Chinese
            </MenuItem>
            <MenuItem
              onClick={() => {
                changeLanguage("pt");
                setSelectedLanguage("Portuguese");
              }}
            >
              Portuguese
            </MenuItem>
          </MenuList>
        </Menu>
      </div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white dark:bg-[#222222] text-left shadow-xl transition-all sm:my-8 w-full sm:w-[50%] sm:p-[24px_24px_30px_24px] ">
                  <div>
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-[13px]">
                        {isDarkTheme ? (
                          <img
                            src="/assets/icons/notification-bing-red.svg"
                            alt="notification-red"
                          />
                        ) : (
                          <img
                            src="/assets/icons/notification-bing.svg"
                            alt="notification"
                          />
                        )}
                        <div>
                          <h1 className="font-bold text-[20px] dark:text-white">
                            {t("Take Action!")}
                          </h1>
                          <p className="text-[#9b9696] dark:text-[#E4232F]">
                            {displayedData.VehiclesNeedAttention}{" "}
                            {t("vehicle need attention")}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="w-14">
                          {isSpeaking ? (
                            <Icon
                              path={mdiStopCircleOutline}
                              size={"25px"}
                              className="dark:text-white cursor-pointer"
                              onClick={stopAudio}
                            />
                          ) : (
                            <Icon
                              path={mdiVolumeHigh}
                              size={"25px"}
                              className="dark:text-white cursor-pointer"
                              onClick={() => speak()}
                            />
                          )}
                        </div>
                        <div className="flex gap-2 items-center">
                          <div className="flex justify-between items-center border border-[#5DA3E9] rounded-md relative bg-[#5DA3E9] shadow-[0px_4px_6px_0px_rgba(242,101,56,0.10)]">
                            <div className="absolute flex items-center justify-center -left-6 top-1/2 w-10 h-10  -translate-y-1/2 bg-[#fff]  rounded-full">
                              <img
                                src="/assets/icons/list_icon.svg"
                                alt="warning"
                                className="w-6 h-6"
                              />
                            </div>

                            <button
                              className="bg-[#5DA3E9] pl-6 text-sm text-white p-3 rounded-md -mr-px"
                              onClick={() => setOpen(true)}
                            >
                              {t("Summary")}
                            </button>
                          </div>
                          <div className="flex items-center gap-[15px]">
                            <IoCloseCircleOutline
                              onClick={() => setOpen(false)}
                              className="cursor-pointer text-[30px] dark:text-white"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="flex mt-[30px] justify-between items-center">
                        <div className="flex items-center gap-[30px] w-full">
                          <div className=" mb-[10px]">
                            <img
                              src="/assets/icons/car_icon.svg"
                              alt="239567"
                              className="w-[51px] min-w-[51px] h-[51px]"
                            />
                          </div>
                          <div className="flex justify-between items-center w-full border-b border-b-[#f2efef] pb-[10px]">
                            <div className="">
                              <h1 className="font-normal text-[17px] text-[#000] dark:text-white">
                                {displayedData?.safety}{" "}
                                {t("vehicles might have a safety issue")}
                              </h1>
                              <p className="text-[#9b9696] my-[7px] dark:text-[#E4232F]">
                                {t("Notify driver!")}
                              </p>
                            </div>
                            <button className="max-w-[115px] twrap px-[10px] py-[5px] bg-[#5DA3E9] text-white text-[16px] font-bold rounded-md flex items-center justify-center w-full relative">
                              {t("Take Action")}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex mt-[30px] justify-between items-center">
                        <div className="flex items-center gap-[30px] w-full">
                          <div className=" mb-[10px]">
                            <img
                              src="/assets/icons/wheel.svg"
                              alt="239568"
                              className="w-[51px] min-w-[51px] h-[51px]"
                            />
                          </div>
                          <div className="flex justify-between items-center w-full border-b border-b-[#f2efef] pb-[10px]">
                            <div>
                              <h1 className="font-normal text-[17px] text-[#000] dark:text-white">
                                {displayedData?.Tire_issue}{" "}
                                {t("vehicles will need new tires next week")}
                              </h1>
                              <p className="text-[#9b9696] my-[7px] dark:text-[#E4232F]">
                                {t("Notify driver!")}
                              </p>
                            </div>
                            <button className="max-w-[115px] twrap px-[10px] py-[5px] bg-[#5DA3E9] text-white text-[16px] font-bold rounded-md flex items-center justify-center w-full relative">
                              {t("Take Action")}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex mt-[30px] justify-between items-center">
                        <div className="flex items-center gap-[30px] w-full">
                          <div className=" mb-[10px]">
                            <img
                              src="/assets/icons/Group 33-3.svg"
                              alt="33"
                              className="w-[51px] min-w-[51px] h-[51px]"
                            />
                          </div>
                          <div className="flex justify-between items-center w-full border-b border-b-[#f2efef] pb-[10px]">
                            <div>
                              <h1 className="font-normal text-[17px] text-[#000] dark:text-white">
                                {displayedData?.Batteries}{" "}
                                {t(
                                  "vehicles will need preventive battery maintenance next month"
                                )}
                              </h1>
                              <p className="text-[#9b9696] my-[7px] dark:text-[#E4232F]">
                                {t("Notify driver!")}
                              </p>
                            </div>
                            <button className="max-w-[115px] twrap px-[10px] py-[5px] bg-[#5DA3E9] text-white text-[16px] font-bold rounded-md flex items-center justify-center w-full relative">
                              {t("Take Action")}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex mt-[30px] justify-between items-center">
                        <div className="flex items-center gap-[30px] w-full">
                          <div className=" rounded-full mb-[10px]">
                            <img
                              src="/assets/icons/graph_icon.svg"
                              alt="239565"
                              className="w-[51px] min-w-[51px] h-[51px]"
                            />
                          </div>
                          <div className="flex justify-between items-center w-full border-b border-b-[#f2efef] pb-[10px]">
                            <div>
                              <h1 className="font-normal text-[17px] text-[#000] dark:text-white">
                                {displayedData?.efficiencyIssue}{" "}
                                {t("vehicles can improve its efficiency")}
                              </h1>
                              <p className="text-[#9b9696] my-[7px] dark:text-[#EBAE1B]">
                                {t("improve now!!")}
                              </p>
                            </div>
                            <button className="max-w-[115px] twrap px-[10px] py-[5px] bg-[#5DA3E9] text-white text-[16px] font-bold rounded-md flex items-center justify-center w-full relative">
                              {t("Take Action")}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex mt-[30px] justify-between items-center">
                        <div className="flex items-center gap-[30px] w-full">
                          <div className=" rounded-full mb-[10px]">
                            <img
                              src="/assets/icons/Handshake.svg"
                              alt="239566"
                              className="w-[51px] min-w-[51px] h-[51px]"
                            />
                          </div>
                          <div className="flex justify-between items-center w-full border-b border-b-[#f2efef] pb-[10px]">
                            <div>
                              <h1 className="font-normal text-[17px] text-[#000] dark:text-white">
                                {displayedData?.driverHabitIssue}{" "}
                                {t(
                                  "drivers improved their habits, resulting in a 3% efficiency gain for your fleet"
                                )}
                              </h1>
                              <p className="text-[#9b9696] my-[7px] dark:text-[#EBAE1B]">
                                {t("Advice drivers now!")}
                              </p>
                            </div>
                            <button className="max-w-[115px] twrap px-[10px] py-[5px] bg-[#5DA3E9] text-white text-[16px] font-bold rounded-md flex items-center justify-center w-full relative">
                              {t("Take Action")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <div>{children}</div>
    </div>
  );
};

export default Header;
